
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

function Pagination({ prevPage, page, showPage, setPage, nextPage }) {
    const { t, i18n } = useTranslation();
    return (
        <motion.div
            className="mt-12 flex justify-center items-center gap-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
        >
            <motion.button

                whileTap={{ scale: 0.9 }}
                onClick={prevPage}
                disabled={page === 1}
                className={`p-2 rounded-full  ${localStorage.getItem("lang") == "ckb" || localStorage.getItem("lang") == "ar" ? "rotate-180" : ""}  ${page === 1
                    ? `text-gray-300 cursor-not-allowed ${localStorage.getItem("lang") == "ckb" || localStorage.getItem("lang") == "ar" ? "rotate-180" : ""} `
                    : `text-[#07A024] hover:bg-gray-100 ${localStorage.getItem("lang") == "ckb" || localStorage.getItem("lang") == "ar" ? "rotate-180" : ""} `
                    }`}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
            </motion.button>

            <div className="flex items-center gap-1 mx-4">
                {[...Array(showPage).keys()].map(num => (
                    <motion.button
                        key={num + 1}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => setPage(num + 1)}
                        className={`w-10 h-10  rounded-lg flex items-center justify-center text-sm font-medium transition-colors ${page === num + 1
                            ? `bg-[#07A024]  text-white shadow-lg`
                            : `text-gray-600 hover:bg-gray-100`
                            }`}
                    >
                        {num + 1}
                    </motion.button>
                ))}
            </div>

            <motion.button
            
                whileTap={{ scale: 0.9 }}
                onClick={nextPage}
                disabled={page === showPage}
                className={`p-2 rounded-full ${localStorage.getItem("lang")  == "ckb" || localStorage.getItem("lang") == "ar" ? "rotate-180" : ""} ${page === showPage
                    ? `text-gray-300 ${localStorage.getItem("lang") == "ckb" || localStorage.getItem("lang") == "ar" ? "rotate-180" : ""}  cursor-not-allowed`
                    : `text-[#07A024] ${localStorage.getItem("lang") == "ckb" || localStorage.getItem("lang") == "ar" ? "rotate-180" : ""}  hover:bg-gray-100`
                    }`}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </motion.button>
        </motion.div>
    )
}

export default Pagination
